import React from "react";
import "./FilterDates.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";

interface PropertyPostFilterDatesProps {
  formik: any;
  lable?: string;
}

const PaymentFilterDates: React.FC<PropertyPostFilterDatesProps> = ({ formik, lable }) => {
  const onChangeStartDate = (e: any) => {
    if (e) {
      formik.setFieldValue("start_date", dayjs(e).format("YYYY-MM-DD"));
    }
  };

  const onChangeEndDate = (e: any) => {
    if (e) {
      formik.setFieldValue("end_date", dayjs(e).format("YYYY-MM-DD"));
    }
  };

  return (
    <div className="payment-filter-new-date-contain">
      <p className="date-head">{lable ? lable : "Created Date"}</p>

      <div className="start-date filter-date-input-contain">
        <p className="date-lable">Start Date</p>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            value={
              formik?.values?.start_date ? dayjs(formik.values.start_date) : null
            }
            onChange={onChangeStartDate}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
                className: "filter-date-input",
              },
            }}
          />
        </LocalizationProvider>
      </div>

      <div className="end-date filter-date-input-contain">
        <p className="date-lable">End Date</p>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            value={
              formik?.values?.end_date ? dayjs(formik.values.end_date) : null
            }
            onChange={onChangeEndDate}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
                className: "filter-date-input",
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default PaymentFilterDates;
